import { ComponentRendering } from '@sitecore-jss/sitecore-jss-react';
import { TProductBuildAndPriceLinkFields, TProductBuildAndPriceLinkProps } from '../types/buildAndPriceLink.types';

export class BuildAndPriceLinkModel {
    private readonly fields?: TProductBuildAndPriceLinkFields;
    private readonly rendering?: ComponentRendering;

    constructor(props: TProductBuildAndPriceLinkProps) {
        this.fields = props?.fields;
        this.rendering = props?.rendering;
    }

    get thumbnailEE(): string {
        return this.fields?.itemData?.thumbnail || '';
    }

    get componentName(): string {
        return this.rendering?.componentName || '';
    }

    get isUnreleased(): boolean {
        return !!this.fields?.isComponentUnreleased;
    }
}
